
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import CONSTANTS from '../../../constants';
import { setServices, selectedServices, setVeiculeInfos } from '../../../actions/action';
import { Select } from "../../Forms/Forms";
import fetchApiData from '../../apiHandlers/fetchApiData';
import Icon from '../../buttons/Icon';
import { pushEventToGTM } from '../../../helpers/trackerManager';
import BesoinsDetailsListRegular from "./besoinsDetailsListRegular";
import BesoinsDetailsListRevision from "./besoinsDetailsListRevision";
import SerieRevision from "./serieRevision";
import BesoinsDetailsListRevisionFlex from './besoinsDetailsListRevisionFlex';
import SerieRevisionFlex from './serieRevisionFlex';
import { priceFormat } from "../../../helpers/functions";

const mapStateToProps = state => state;
const mapDispatchToProps = { setServices, selectedServices, setVeiculeInfos };

class BesoinsItem extends PureComponent {
  static defaultProps = {
    className: "",
    label: "",
    forfaits: [],
    id: "",
    totalPrice: 0,

  };
  constructor(props) {
    super(props);
    this.state = {
      blockEmpty: true,
      height: 0,
      totalPrice: 0,
      selectedForfaitsNames: [],
      isAforfait: false,
      showDetails: false,
      showRevisionVin: false,
      isKilometrageSelected: false,
      kilometrageData: [],
      showForfaitsEntretien: false,
      selectedKilometrage: "",
      offsetTop: 0,

    };
    this.besoinItemRef = React.createRef();
    this.removeFromSelected = this.removeFromSelected.bind(this);
    this.updateSelected = this.updateSelected.bind(this);
    this.updateItemNamesAndPrices = this.updateItemNamesAndPrices.bind(this);
    this.loadPas = this.loadPas.bind(this);
    this.loadForfaitsEntretien = this.loadForfaitsEntretien.bind(this);
    this.updateItemNamesAndPricesFromStore = this.updateItemNamesAndPricesFromStore.bind(this);
    this.deselectOtherBlock = this.deselectOtherBlock.bind(this);
    this.currencyPlacement = !!Number(window.siteConfig.PoundPlacement);
  }
  removeFromSelected(id) {
    const oldData = this.props.store.SelectedServices.slice();
    const filtredServices = oldData.filter(function (item) {
      return item.interventionId != id;
    });
    this.props.selectedServices(filtredServices.slice());
  }
  updateSelected(data) {
    const SelectedServices = Object.assign({}, this.props.store.SelectedServices);
    let newData = [];
    if (data.length) {
      newData = Object.values(SelectedServices).map(function (item) {
        data.map(function (selectedF) {
          if (item.codeFamilyForfait != null && item.codeFamilyForfait.indexOf(selectedF.Code) > -1) {

            item.forfaits = data;
            this.updateItemNamesAndPrices(selectedF.Code);

          }
        }.bind(this));

        return item;
      }.bind(this));
      this.props.selectedServices(newData);

    }
  }
  loadPas() {
    const pasForfaits = new fetchApiData();

    pasForfaits.getPas({
      "geoID": this.props.store.dealer.geoID,
      "mileage": this.props.store.kilo.kilometrage,
      "vin": this.props.store.car.SerialNumber
    }).then(
      data => {
        const listPas = [];
        data.d.map(function (value) {
          listPas[value.Value] = value.Text;
        });
        this.loadForfaitsEntretien(data.d[0].Value);
        this.setState({ kilometrageData: listPas });
      })
      .catch(error => {
        console.log('error getPas : ', error)
      });

  }
  loadForfaitsEntretien(pasValue) {
    this.setState({ selectedKilometrage: pasValue });
    const forfaitsEntretien = new fetchApiData();
    const { car } = this.props.store;
    this.props.setVeiculeInfos({ ...car, "carStep": pasValue });

    forfaitsEntretien.getForfaitEntretien({
      "pasCode": pasValue
    }).then(
      data => {
        const storeData = Object.assign({}, this.props.store.service);

        storeData.forfaits[0].SubFunctionList = Object.assign({}, data.d.FunctionData.SubFunctionList);

        this.props.setServices(storeData);
        this.updateItemNamesAndPricesFromStore();

        if (data.d.ErrorCode == 0) {
          this.setState({ showForfaitsEntretien: true, blockEmpty: false });
        }
        else {
          console.error(data.d);
        }

      })
      .catch(error => {
        console.log('error getPas : ', error)

      });
  }
  updateItemNamesAndPrices(code) {
    let total = 0;
    const names = [];
    const store = this.props.store;
    const SelectedServices = Object.assign({}, this.props.store.SelectedServices);
    Object.values(SelectedServices).map(function (forfaitType, key) {
      if (forfaitType.codeFamilyForfait != null && forfaitType.codeFamilyForfait.indexOf(code) > -1) {
        forfaitType.forfaits.map(function (forfaitItem, key) {
          forfaitItem.SubFunctionList[0].ForfaitList.map(function (forfait, keyforfait) {
            // calculate forfaits prices
            if (forfait.isSelected) {
              total += (!!Number(store.booking.happy) ? (forfait.Items[0].Prix - (forfait.Items[0].Prix * 0.01 * store.booking.happy).toFixed(2)) : forfait.Items[0].Prix);
              names.push(forfait.Libelle);
              // add Operations prices
              if (forfait.Operations != null) {
                forfait.Operations.map(function (Operation, opKey) {
                  if (Operation.isSelected) {

                    total += (!!Number(store.booking.happy) ? (Operation.Items[0].Prix - (Operation.Items[0].Prix * 0.01 * store.booking.happy).toFixed(2)) : Operation.Items[0].Prix);
                    names.push({ 'operation': Operation.Libelle });

                    return Operation;
                  }

                });
              }

            }

            return forfait;
          });
          return forfaitItem;
        });
      }
      return forfaitType;
    });

    this.setState({ totalPrice: total, blockEmpty: true, selectedForfaitsNames: names });
  }
  updateItemNamesAndPricesFromStore() {
    let total = 0;
    const names = [];
    const forfaitOrOperactionCode = this.props.forfaits.codeFamilyForfait;
    const store = this.props.store;
    const SelectedServices = Object.assign({}, this.props.store.SelectedServices);
    Object.values(SelectedServices).map(function (forfaitType, key) {
      if ((forfaitType.codeFamilyForfait != null && forfaitType.codeFamilyForfait.indexOf(forfaitOrOperactionCode) > -1)) {
        forfaitType.forfaits.map(function (forfaitItem, key) {
          Object.keys(forfaitItem.SubFunctionList).length > 0 &&
            forfaitItem.SubFunctionList[0].ForfaitList.map(function (forfait, keyforfait) {
              // calculate forfaits prices
              if (forfait.isSelected) {
                total += (!!Number(store.booking.happy) ? (forfait.Items[0].Prix - (forfait.Items[0].Prix * 0.01 * store.booking.happy).toFixed(2)) : forfait.Items[0].Prix);
                names.push(forfait.Libelle);
                // add Operations prices
                if (forfait.Operations != null) {
                  forfait.Operations.map(function (Operation, opKey) {
                    if (Operation.isSelected) {

                      total += (!!Number(store.booking.happy) ? (Operation.Items[0].Prix - (Operation.Items[0].Prix * 0.01 * store.booking.happy).toFixed(2)) : Operation.Items[0].Prix);
                      names.push({ 'operation': Operation.Libelle });


                      return Operation;
                    }

                  });
                }

              }

              return forfait;
            });
          return forfaitItem;
        });
      }
      return forfaitType;
    });
    this.setState({ totalPrice: total, blockEmpty: true, selectedForfaitsNames: names });
  }

  componentDidMount() {
    if (window.isMobile() !== 'desktop') {
      window.scrollTo(0, 0);
    }

    // Run this function to show selected services in case the user get back to vosBesoin Page and want to change his choices.
    this.updateItemNamesAndPricesFromStore();
    this.setState({
      height: this.besoinItemRef.clientHeight,
      offsetTop: this.besoinItemRef.current,
      isAforfait: (this.props.forfaits.forfaits != null && this.props.forfaits.forfaits.length &&
        this.props.forfaits.forfaits[0].hasForfait),
    });

  }

  componentDidUpdate(prevProps, prevState) {
    this.setState({
      height: this.besoinItemRef.clientHeight,
      offsetTop: this.besoinItemRef.current,
      isAforfait: (this.props.forfaits.forfaits != null && this.props.forfaits.forfaits.length &&
        this.props.forfaits.forfaits[0].hasForfait),
    });
  }

  deselectOtherBlock(element, etat) {
    var parentNodeItem = element.currentTarget.parentNode.parentNode.parentNode.parentNode;
    const ISOPENBLOCK = 'isOpenBlock'
    if (document.querySelector(`.${ISOPENBLOCK}`) === null) {
      parentNodeItem.classList.add(ISOPENBLOCK);
      if (etat === 'revision') {
        this.setState({ showRevisionVin: true });
        if (CONSTANTS.SITE_INFO.BRAND_CODE === "C") {
          element.currentTarget.classList.add('isOpen');
          element.currentTarget.parentNode.parentNode.classList.add('isOpen');
        }
      }
      else {
        this.setState({ blockEmpty: false });
        this.setState({ showRevisionVin: false });
      }
    } else {
      if (parentNodeItem.classList.contains(ISOPENBLOCK)) {
        parentNodeItem.classList.remove(ISOPENBLOCK);

        if (etat === 'revision') {
          this.setState({ showRevisionVin: false });
          if (CONSTANTS.SITE_INFO.BRAND_CODE === "C") {
            element.currentTarget.classList.remove("isOpen");
            element.currentTarget.parentNode.parentNode.classList.remove("isOpen");
          }
        } else {
          this.setState({ blockEmpty: true });
        }
      } else {
        if (document.querySelector('.isOpen') && CONSTANTS.SITE_INFO.BRAND_CODE !=="C") {
          document.querySelector(`.${ISOPENBLOCK}`).childNodes[0].childNodes[0].childNodes[2].childNodes[0].classList.remove('isOpen')
          document.querySelector(`.${ISOPENBLOCK}`).childNodes[0].childNodes[0].childNodes[2].classList.remove('isOpen')
          document.querySelector(`.${ISOPENBLOCK}`).childNodes[0].childNodes[0].classList.remove('isOpen')
        }
        document.querySelector(`.${ISOPENBLOCK}`).classList.remove(ISOPENBLOCK);
        parentNodeItem.classList.add(ISOPENBLOCK);
        this.setState({ showDetails: {} })
        if (etat === 'revision') {
          this.setState({ showRevisionVin: true });
        } else {
          this.setState({ blockEmpty: false });
        }
      }
    }
  }
  onInfoIconCliked = (e) => {
    var parentNodeItem = e.currentTarget.parentNode.parentNode.parentNode.parentNode.parentNode;

    if (document.querySelector('.isOpenBlock') === null) {
      parentNodeItem.classList.add('isOpenBlock');
    } else {
      document.querySelector('.isOpenBlock').classList.remove('isOpenBlock');
      parentNodeItem.classList.add('isOpenBlock');
      this.setState({ showDetails: {} })
    }
    this.setState({ showDetails: `${CONSTANTS.LABELS.needs_basket_nopriceavailable2}` })
  }
  
  onInfoIconClikedCitroen = (e) => {
    var parentNodeItem = e.currentTarget.parentNode.parentNode;

    if (document.querySelector('.isOpenBlock') === null) {
      parentNodeItem.classList.add('isOpenBlock');
    }
    else if (
           document.querySelector(".isOpenBlock") &&
           parentNodeItem.classList.contains("isOpenBlock")
         ) {
          parentNodeItem.classList.remove("isOpenBlock");
         } 
         else {
           document
             .querySelector(".isOpenBlock")
             .classList.remove("isOpenBlock");
           parentNodeItem.classList.add("isOpenBlock");
           this.setState({ showDetails: {} });
         }
    this.setState({ showDetails: `${CONSTANTS.LABELS.needs_basket_nopriceavailable2}` })
  }

  render() {
    const classes = (!this.state.blockEmpty ? ' ' : 'isOpen');
    const classesRevision = (!this.state.blockEmpty ? '' : 'isOpen');
    const { label, id, forfaits } = this.props;
    const isNotyetSelected = (this.state.selectedForfaitsNames.length < 1 && this.state.isAforfait ? true : false);
    const itHasSelectedServices = (this.state.selectedForfaitsNames.length > 0 && this.state.isAforfait ? true : false);
    const itHasNotaPrice = (!this.state.totalPrice && this.state.isAforfait ? true : false);
    const ifForfaitPricesActivated = !!parseInt(window.siteConfig['ActivateFFPrices']);
    return (
      <div className={window.siteConfig.currentBrand === 'C' ? " services-details__item isOpenBlock ": "services-details__item"} ref={this.besoinItemRef}>
        <div className="services-details__item-wrapper" >
          {/* show forfaits details on popin above forfait selected. */}
          {!!this.state.showDetails.length && 
            CONSTANTS.SITE_INFO.BRAND_CODE !== "C" &&
            <div className="service-item__details-popin"
              onClick={(e) => {
                var parentNodeItem = e.currentTarget.parentNode.parentNode;
                if (parentNodeItem.classList.contains('isOpenBlock')) {
                  parentNodeItem.classList.remove('isOpenBlock');
                  this.setState({ showDetails: {} })
                }
              }
              }>
              {typeof this.state.showDetails == 'object' && this.state.showDetails.length && this.state.showDetails.map(function (item, key) {
                return <span key={key}>{key + 1} - {item.Text}<br /></span>;
              })}
              {typeof this.state.showDetails == 'string' && this.state.showDetails.length && <span dangerouslySetInnerHTML={{ __html: (this.state.showDetails) }}></span>}

            </div>
          }

          <div className={ window.siteConfig.currentBrand === 'C' ? `services-details__item-summary isOpen ${classes}` : `services-details__item-summary ${classes}`  }  >
            <div className="service-item__icon item-row">
              <Icon dataImage={`${this.props.imageUrl}`} />
            </div>
            <div tabIndex="0" className="service-item__headline item-row">
              <h4 className="headline__title">{label}</h4>
              {ifForfaitPricesActivated && isNotyetSelected && 
                <p className={"headline__subtitle noPriceSelectedTitle"}>
                {CONSTANTS.LABELS.needs_basket_noprice}
                </p>}

              {itHasSelectedServices && this.state.selectedForfaitsNames.map(function (title, key) {

                if (typeof title == 'object') {
                  return <React.Fragment key={key}><p className="headline__subtitle_operation" >{title.operation}</p> </React.Fragment>;
                }

                else {
                  return <React.Fragment key={key}><p className="headline__subtitle" >{title}</p> </React.Fragment>;
                }

              })
              }
              { /*show "Details" button on desktop just after the forfait Name if there is selected services*/
                (window.isMobile() === 'desktop' && (itHasSelectedServices && this.state.isKilometrageSelected || itHasSelectedServices)) &&
                <span tabIndex='0' className={`service-item__showDetails ${classes}`}
                  onClick={(e) => {
                    (this.state.blockEmpty && this.state.isKilometrageSelected ? this.setState({ blockEmpty: false }) :
                    this.setState({ blockEmpty: true }));
                    forfaits.forfaits[0].isConstructeur && (this.setState({ showForfaitsEntretien: true, isKilometrageSelected: true }))
                    this.deselectOtherBlock(e)
                  }
                  }
                  onKeyDown={
                    (e) => {
                      if (e.key === 'Enter') {
                        (this.state.blockEmpty ? this.setState({ blockEmpty: false }) : this.setState({ blockEmpty: true }))
                        forfaits.forfaits[0].isConstructeur && (this.setState({ showForfaitsEntretien: true, isKilometrageSelected: true }))
                      }
                    }
                  }>
                  {CONSTANTS.LABELS.common_v2_detail}
                </span>
              }

            </div>
            {/* if this forfait is NOT a revision constructeur */}
            {(ifForfaitPricesActivated && itHasNotaPrice && !forfaits.forfaits[0].isConstructeur) &&
              <div className={`service-item__rowChoice item-row ${classes}`}>
                <div className={`priceChoice__button ${classes}`}
                  tabIndex='0'
                  onKeyDown={
                    (e) => {
                      if (e.key === 'Enter') {
                        pushEventToGTM({
                          pageName: 'services',
                          eventAction: 'Click::CTA',
                          eventLabel: 'operations_seeprices'
                        })
                        this.deselectOtherBlock(e)
                      }

                    }
                  }
                  onClick={(e) => {
                    pushEventToGTM({
                      pageName: 'services',
                      eventAction: 'Click::CTA',
                      eventLabel: 'operations_seeprices'
                    });
                    this.deselectOtherBlock(e);

                  }}>
                  {CONSTANTS.SITE_INFO.BRAND_CODE !== "C" && 
                  <p className="priceChoice__title">
                    <span>{CONSTANTS.LABELS.needs_basket_choseprice}</span>
                    <span className="priceChoice__infos" dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.needs_basket_optional) }}></span>
                  </p>}
                  
                  {CONSTANTS.SITE_INFO.BRAND_CODE === "C" && 
                  <div className="priceChoice__title">
                    <span>{CONSTANTS.LABELS.needs_basket_choseprice}</span>{" "}
                    <span dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.needs_basket_optional) }}></span>
                  </div>}
                </div>
              </div>
            }
            {/* if this forfait is  a revision constructeur */}
            {(ifForfaitPricesActivated && itHasNotaPrice && forfaits.forfaits[0].isConstructeur) &&
              <div className={`service-item__rowChoice item-row ${classes}  `}>
                <div className={`priceChoice__button ${classes}`}
                  tabIndex='0'
                  onKeyDown={
                    (e) => {
                      if (e.key === 'Enter') {
                        pushEventToGTM({
                          pageName: 'services',
                          eventAction: 'Click::CTA',
                          eventLabel: 'operations_seeprices_revision'
                        })

                        this.deselectOtherBlock(e, 'revision')
                      }

                    }
                  }
                  onClick={(e) => {

                    (this.state.blockEmpty && this.state.isKilometrageSelected ? this.setState({ blockEmpty: false }) :
                      this.setState({ blockEmpty: true }));
                    pushEventToGTM({
                      pageName: 'services',
                      eventAction: 'Click::CTA',
                      eventLabel: 'operations_seeprices_revision'
                    });
                    //this.setState({showRevisionVin: !this.state.showRevisionVin});
                    this.deselectOtherBlock(e, 'revision');
                  }
                  }>
                  {CONSTANTS.SITE_INFO.BRAND_CODE !== "C" && 
                  <p className="priceChoice__title">
                    <span>{CONSTANTS.LABELS.needs_basket_choseprice}</span>
                    <span className="priceChoice__infos" dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.needs_basket_optional) }}></span>
                  </p>}
                  
                  {CONSTANTS.SITE_INFO.BRAND_CODE === "C" && 
                  <div className="priceChoice__title">
                    <span>{CONSTANTS.LABELS.needs_basket_choseprice}</span>{" "}
                    <span dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.needs_basket_optional) }}></span>
                  </div>}
                  
                </div>
                {
                  this.state.showRevisionVin &&
                  !this.state.isKilometrageSelected && 
                  CONSTANTS.SITE_INFO.BRAND_CODE !== "C" &&
                  <SerieRevision
                    vinSuccess={(e) => this.setState({ isKilometrageSelected: true })}
                    fillPasSelect={(data) => { this.loadForfaitsEntretien(data.selected); this.setState({ kilometrageData: data.listPas }) }}
                    ClosePopin={(e) => this.setState({ showRevisionVin: false })} />}
              </div>
            }
            {/* if this forfait is  a revision constructeur && kilomettrage is not yet assigned */}
            {(ifForfaitPricesActivated && itHasNotaPrice && forfaits.forfaits[0].isConstructeur && this.state.isKilometrageSelected) &&
              <div className={`service-item__rowChoice distance--select item-row `}>
                <ul className={`row_wrapper ${classesRevision}`} >
                  <li className={"title-item"}>{CONSTANTS.LABELS.account_km1}</li>
                  <li className={"form-item"}>
                    <Select Options={this.state.kilometrageData}
                      Name={CONSTANTS.LABELS.needs_basket_km}
                      Selected={this.state.selectedKilometrage}
                      onChange={(e) => {
                        this.loadForfaitsEntretien(e.target.value);
                        this.setState({ selectedKilometrage: e.target.value });
                      }
                      }
                      Inverse={true}
                    />
                  </li>
                </ul>
              </div>
            }
            {(ifForfaitPricesActivated && !this.state.isAforfait) &&
              <div className={`service-item__rowChoice item-row `}>
                <div className={`priceChoice__button noprice`} >
                  <p className="priceChoice__title" dangerouslySetInnerHTML={{ __html: (window.isMobile() == 'desktop' ? CONSTANTS.LABELS.needs_basket_nopriceavailable1 : CONSTANTS.LABELS.needs_basket_nopriceavailable1_mobile) }}>

                  </p>
                  {CONSTANTS.SITE_INFO.BRAND_CODE !== "C" && 
                  <Icon
                    isTabIndexActivate={true}
                    onKeyDown={(e) => e.key === 'Enter' && this.onInfoIconCliked(e)}
                    Name="info-active"
                    onClick={this.onInfoIconCliked}
                  />}

                  {CONSTANTS.SITE_INFO.BRAND_CODE === "C" && 
                    <div className="iconContainer">
                      <span 
                      className={!!this.state.showDetails.length ? "forfaitIconInfo isClicked" : "forfaitIconInfo"} 
                      tabIndex={'0'}
                      onKeyDown={(e) => e.key === 'Enter' && this.onInfoIconClikedCitroen(e)}
                      name="info-active"
                      onClick={this.onInfoIconClikedCitroen}
                      ></span>
                      
                      {!!this.state.showDetails.length && 
                        <div className="forfaitPopup"
                          onClick={(e) => {
                            var parentNodeItem = e.currentTarget.parentNode.parentNode;
                            if (parentNodeItem.classList.contains('isOpenBlock')) {
                              parentNodeItem.classList.remove('isOpenBlock');
                              this.setState({ showDetails: {} })
                            }
                          }
                          }>
                          {typeof this.state.showDetails == 'object' && this.state.showDetails.length && this.state.showDetails.map(function (item, key) {
                            return <span key={key}>{key + 1} - {item.Text}<br /></span>;
                          })}
                          {typeof this.state.showDetails == 'string' && this.state.showDetails.length && <span dangerouslySetInnerHTML={{ __html: (this.state.showDetails) }}></span>}

                        </div>
                      }
                    </div>
                  }

                </div>
              </div>
            }
            {!!this.state.totalPrice && !!this.state.isAforfait &&
              <div className={`service-item__priceDetails item-row ${classes}`}>
                <p className="priceDetails__title">
                  {/*  Discount & Total Price message for Mobile*/}
                  {
                    (this.props.store.booking &&
                      !!Number(this.props.store.booking.happy) &&
                      window.isMobile() !== 'desktop'
                    ) &&
                    <span dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.needs_basket_discount_applied) }}></span>
                  }
                  {
                    (this.props.store.booking &&
                      !Number(this.props.store.booking.happy) &&
                      window.isMobile() !== 'desktop'
                    ) &&
                    <span>{CONSTANTS.LABELS.needs_basket_maintenance_label9}</span>
                  }
                  {/* END - Discount & Total Price message for Mobile*/}

                  {priceFormat(parseFloat(this.state.totalPrice).toFixed(2))}{` ${CONSTANTS.LABELS.needs_basket_label2}`}
                </p>
                {/*  Discount message for Desktop*/}
                {
                  (this.props.store.booking &&
                    !!Number(this.props.store.booking.happy) &&
                    window.isMobile() === 'desktop'
                  ) &&
                  <span className="item-price-message">{CONSTANTS.LABELS.needs_basket_discount_applied}</span>
                }

                {/* END - Discount message for Desktop*/}
              </div>
            }
            { /*show "Details" button on mobile just after the forfait Name if there is selected services*/
              (window.isMobile() !== 'desktop' && (itHasSelectedServices && this.state.isKilometrageSelected || itHasSelectedServices)) &&
              <span className={`service-item__showDetails ${classes}`} onClick={(e) => { (this.state.blockEmpty ? this.setState({ blockEmpty: false }) : this.setState({ blockEmpty: true })) }}>
                {CONSTANTS.LABELS.common_v2_detail}
              </span>
            }



            <div className="service-item__delete item-row">
              <Icon
                Name="delete"
                onClick={() => this.removeFromSelected(id)}
                isTabIndexActivate={true}
                onKeyDown={(e) => e.key === 'Enter' && this.removeFromSelected(id)}
              />
            </div>
          </div>

          {/* if this forfait is NOT a revision constructeur */}
          {!this.state.blockEmpty && !forfaits.forfaits[0].isConstructeur &&
            <div className="services-details__item-body"
              style={{ top: `${this.state.height}px`, zIndex: 100 - Number(this.props.zindex) }}>
              <div className="services-details__item-body__wrapper">
                <BesoinsDetailsListRegular
                  data={forfaits.forfaits}
                  getSelectedForfait={this.updateSelected}
                  numberOfselected={this.state.selectedForfaitsNames.length} />
              </div>
            </div>
          }

          {/* if this forfait is  a revision constructeur and not for Citroen */}
          {(!this.state.blockEmpty && this.state.showForfaitsEntretien && this.state.isKilometrageSelected) &&
            CONSTANTS.SITE_INFO.BRAND_CODE !== 'C' &&
            <div className="services-details__item-body" style={{ top: `${this.state.height}px`, zIndex: 100 - Number(this.props.zindex) }}>
              <div className="services-details__item-body__wrapper isOpenBlock">
                <BesoinsDetailsListRevision
                  data={forfaits.forfaits}
                  getSelectedForfait={this.updateSelected}
                  getshowDetails={(e) => {
                    this.setState({ showDetails: e });
                  }
                  }
                  numberOfselected={this.state.selectedForfaitsNames.length} />
              </div>
            </div>}
          
          {/* if this forfait is  a revision constructeur and for Citroen */}
          {(!this.state.blockEmpty && this.state.showForfaitsEntretien && this.state.isKilometrageSelected) &&
            CONSTANTS.SITE_INFO.BRAND_CODE === 'C' &&
            <BesoinsDetailsListRevisionFlex
              data={forfaits.forfaits}
              getSelectedForfait={this.updateSelected}
              getshowDetails={(e) => {
                this.setState({ showDetails: e });
              }}
              numberOfselected={this.state.selectedForfaitsNames.length}
            />
            }
            
            {
              this.state.showRevisionVin &&
              !this.state.isKilometrageSelected && 
              CONSTANTS.SITE_INFO.BRAND_CODE === "C" &&
              <SerieRevisionFlex
                vinSuccess={() => this.setState({ isKilometrageSelected: true })}
                fillPasSelect={(data) => { this.loadForfaitsEntretien(data.selected); this.setState({ kilometrageData: data.listPas }) }}
                ClosePopin={() => this.setState({ showRevisionVin: false })} />
            }
        </div>
      </div>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(BesoinsItem);
